/**
 * External Links Dialog
 */
const $ = window.jQuery;

export class ExternalLinks {
  constructor() {
    this.links();
    this.cancel();
    this.continue();
    this.modal();
  }

  links() {
    // About to leave website...
    $(`a[href^="https://"], a[href^="http://"]`).each((index, element) => {
      const href = $(element).attr("href");
      if (href.includes(location.host) || href.includes("forms.fivision.com") || href.includes("mymortgage-online.com") || href.includes("coastal1online.org") || href.includes(`applicantpro.com`)) return;
      $(element).attr("data-external-link", "click");
    });
  }

  cancel() {
    $(document).on("click", `[data-external-link="cancel"]`, (event) => {
      event.preventDefault();
      $.magnificPopup.close();
    });
  }

  continue() {
    $(document).on("click", `[data-external-link="continue"]`, (event) => {
      event.preventDefault();
      location.href = this.href;
    });
  }

  ameriprise() {
    if (!this.href.includes("ameriprise")) return;

    const url = new URL(this.href);
    const from = location.host.replace("www.", "");
    const to = url.host.replace("www.", "");

    $(".external-link-confirmation__header h2").text(`You are now leaving ${from} and going to ${to}`);
    $(".external-link-confirmation__body p").text(`${to} is not owned or operated by Coastal1 Credit Union and has its own privacy policy and terms of use. We encourage you to read through both and familiarize yourself with the site before completing a transaction. Coastal1 Credit Union is not responsible for the availability or content of this site on ${to} and does not represent either Ameriprise Financial, Inc. or you, should you enter into a transaction.`);
  }

  modal() {
    $(document).on("click", `[data-external-link="click"]`, (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.href = $(event.currentTarget).attr("href");
      this.ameriprise();
      this.open("external-link-confirmation");
      return false;
    });
  }

  open(id) {
    if (!id) return;

    $.magnificPopup.open({
      items: {
        src: `#${id}`,
        type: "inline",
      },
    });
  }
}
